import React from 'react';

import type { Props } from '@travel/traveler-core/components/Dialog';
import DialogCore from '@travel/traveler-core/components/Dialog';

function Dialog(props: Props) {
  return <DialogCore {...props} />;
}

export default Dialog;
